module.exports = __webpack_public_path__ + "img/l11.823356ad.jpg";